<template>
  <div class="content-body">
    <div class="head-body">
      <div class="left-icon">
        <div class="top-icon">
          <i class="el-icon-money"></i>
        </div>
        <div class="bottom-icon">
          <i class="fa fa-line-chart"></i>
        </div>
      </div>
      <div class="center-content">
        <div class="top-content">
          <div class="font">今日消费 <span v-text="data.today_pay"></span></div>
          <div class="font">账户余额 <span v-text="data.company_balance"></span></div>
          <div class="font">每日预算 <span>{{ showBudgetTitle(data.company_budget) }}</span><i title="点击修改" class="el-icon-edit" style="cursor: pointer; color: #666; margin-left: 10px;" @click="showBudget"></i></div>
        </div>
        <div class="bottom-content">
          <div class="font">投放创意 <span v-text="data.action_adv"></span></div>
          <div class="font">审核创意 <span v-text="data.handle_adv"></span></div>
          <div class="font">暂停创意 <span v-text="data.fre_adv"></span></div>
        </div>
      </div>
      <div class="right-btn" @click="jumpPlan">
        <div class="icon">
          <i class="fa fa-plus-circle" aria-hidden="true"></i>
        </div>
        新建推广计划
      </div>
    </div>

    <div id="echarts-records" :style="{width: 'calc(100% - 20px)', height: 'calc(100% - 200px)', marginLeft: '10px', marginTop: '20px'}"></div>

    <el-dialog title="修改账户预算" :close-on-click-modal="false" :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" label-width="80px" label-position="left">
        <el-form-item label="预算方式">
          <el-radio-group v-model="checked">
            <el-radio-button :label="1">不限预算</el-radio-button>
            <el-radio-button :label="0">指定预算</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="指定预算" v-show="checked !== 1">
          <el-input v-model="input" placeholder="预算设置0元即暂停"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sure" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import echarts from 'echarts';
// @ is an alias to /src
export default {
  name: 'index',
  data() {
    return {
      curentComponents: 'PlanView',
      data: [],
      dialogVisible: false,
      input: '',
      checked: 0
    };
  },
  created() {
    this.$http.post('/trader/index/getIndexInfo').then(res => {
      console.log(res);
      if (res.code === 200) {
        this.data = res.data;
        this.checked = parseFloat(res.data.company_budget) >= 999999999999 ? 1 : 0;
        this.input = parseFloat(res.data.company_budget);
        this.$function.hiddenLoading();
        this.getLine();
      }
    });
  },
  methods: {
    getLine() {
      this.$http.post('/trader/data/getIndexCount', {
        dateType: 2
      }).then(res => {
        if (res.code === 200) {
          this.$function.hiddenLoading();
          // this.pay_money = res.data.pay_money;
          // this.look_num = res.data.look_num;
          // this.read_num = res.data.read_num;

          // 填充数据表格
          const echartsRecords = echarts.init(document.getElementById('echarts-records'), 'walden');
          const option = {
            title: {
              text: '实时数据更新，最新一周数据'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#6a7985'
                }
              }
            },
            legend: {
              data: ['曝光', '点击', '支付']
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [{
              type: 'category',
              boundaryGap: false,
              data: res.chat.name
            }],
            yAxis: [{
              type: 'value'
            }],
            series: [
              {
                name: '支付',
                type: 'line',
                stack: '总量',
                areaStyle: {
                  color: '#C4E7FF'
                },
                data: res.chat.pay
              },
              {
                name: '点击',
                type: 'line',
                stack: '总量',
                areaStyle: {},
                data: res.chat.cpc
              },
              {
                name: '曝光',
                type: 'line',
                stack: '总量',
                label: {
                  normal: {
                    show: true,
                    position: 'top'
                  }
                },
                areaStyle: {},
                data: res.chat.exposure
              }
            ]
          };

          echartsRecords.setOption(option);
        }
      });
    },
    sure() {
      this.$http.post('/trader/index/updateBudget', {
        budget: this.input
      }).then(res => {
        if (res.code === 200) {
          this.data.company_budget = this.input;
          this.$message.success('操作成功');
        } else {
          this.$message.error(res.msg);
        }
        this.dialogVisible = false;
      });
    },
    showBudget() {
      this.checked = parseInt(this.input) === 999999999999 ? 1 : 0;
      this.dialogVisible = true;
    },
    showBudgetTitle(val) {
      return parseInt(val) >= 999999999999 ? '不限' : val;
    },
    jumpPlan() {
      this.$emit('jump_plan');
    }
  },
  watch: {
    checked(newVal) {
      this.input = parseInt(newVal) ? 999999999999 : 0;
    }
  }
};
</script>
<style lang="less" scoped="">
  .head-body {
    display: flex;
    width: 100%;
    height: 160px;
    .left-icon {
      width: 120px;
      font-size: 32px;
      color: #0056AF;
      text-align: center;
      border-right: 1px solid #fff;
      div {
        height: 80px;
        line-height: 80px;
      }
      .top-icon {
        background: #C4E7FF;
      }
      .bottom-icon {
        border-top: 1px solid #fff;
        background: #E1F1FE;
      }
    }

    .center-content {
      width: calc(100% - 280px);
      border-right: 1px solid #fff;
      .top-content, .bottom-content {
        display: flex;
        justify-content: space-between;
        height: 80px;
        line-height: 80px;
      }
      .top-content {
        background: #C4E7FF;
      }
      .bottom-content {
        border-top: 1px solid #fff;
        background: #E1F1FE;
      }
      .font {
        width: 33.3%;
        text-align: center;
        span {
          margin-left: 10px;
          color: #0056AF;
          font-weight: 500;
        }
      }
    }

    .right-btn {
      width: 160px;
      height: 160px;
      text-align: center;
      color: #221815;
      font-size: 16px;
      background: #C5E2FF;
      cursor: pointer;
      i {
        color: #0056AF;
        font-size: 48px;
        margin-top: 45px;
      }

    }
  }
</style>
